import React from "react";
const Heading = ()=>{
  return(
    <div id="heading">
      <div class="headline">
        <h1>The Plant Based Guide</h1>
        <h2>Don't change your diet. </h2>
        <h3>Enhance it!</h3>
      </div>
    </div>
  )
}
export default Heading
